import script from "./PaymentTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentTab.vue?vue&type=script&setup=true&lang=js"

import "./PaymentTab.vue?vue&type=style&index=0&id=734985ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734985ae"]])

export default __exports__